<template>
  <transition name="popup">
    <slot />
  </transition>
</template>

<script>
export default {
  name: 'PopupTransition',
}
</script>

<style lang="scss">
@import "../../../../assets/sass/abstracts";
.popup-enter-active,
.popup-leave-active {
  transition: all .3s ease;

  .card, .overlay {
    transition: all .3s ease;
  }
}

.popup-enter, .popup-leave-to {
  .card {
    transform-origin: top center;
    transform: translateY(-40px) scale(0.8);
    opacity: 0;
  }

  .overlay {
    opacity: 0;
  }
}
</style>
